import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PolicyPipesModule } from '@amfam/policy/pipes';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { PremiumDetailComponent } from './premium-detail/premium-detail.component';
import { PremiumDetailsComponent } from './premium-details/premium-details.component';
import { RiskItemComponent } from './risk-item/risk-item.component';
import { YearVinComponent } from './year-vin/year-vin.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([]),
    PolicyPipesModule,
    PipesModule
  ],
  declarations: [
    PremiumDetailsComponent,
    PremiumDetailComponent,
    RiskItemComponent,
    YearVinComponent
  ],
  exports: [PremiumDetailsComponent, PremiumDetailComponent, RiskItemComponent, YearVinComponent]
})
export class PolicyReplaceVehicleUiModule {}
